/**
 * WordPress Dependencies
 */
import { Flex, FlexBlock, FlexItem, SelectControl } from '@wordpress/components';
import { withInstanceId } from '@wordpress/compose';
import { __ } from '@wordpress/i18n';

/**
 * Internal Dependencies
 */
import ResLabelControl from '../res-label-control';
import { MASK_POSITIONS, MASK_REPEATS, MASK_SHAPES, MASK_SIZES } from './constants';

import { PREFIX } from '../../constants';

const MaskControl = ({ label = '', controlName, objAttrs, instanceId }) => {
    const { attributes, setAttributes } = objAttrs;

    const {
        [`${PREFIX}${controlName}MaskShape`]: maskShape,
        [`${PREFIX}${controlName}MaskSize`]: maskSize,
        [`${PREFIX}${controlName}MaskPosition`]: maskPosition,
        [`${PREFIX}${controlName}MaskRepeat`]: maskRepeat
    } = attributes;

    return (
        <div className="faqmate-control-container">
            {label && (
                <div className="faqmate-mb-8">
                    <ResLabelControl
                        requiredProps={{
                            id,
                            setAttributes,
                            attributes
                        }}
                        label={label}
                        noResBtns={true}
                    />
                </div>
            )}
            <div className="mask-properties">
                <div className="single-mask-property">
                    <Flex>
                        <FlexBlock>
                            <label htmlFor={`shape-${instanceId}`}>{__('Shape', 'faqmate-blocks')}</label>
                        </FlexBlock>
                        <FlexItem>
                            <SelectControl
                                id={`shape-${instanceId}`}
                                value={maskShape}
                                options={MASK_SHAPES}
                                onChange={maskShape => setAttributes({ [`${PREFIX}${controlName}MaskShape`]: maskShape })}
                            />
                        </FlexItem>
                    </Flex>
                </div>
                {maskShape !== 'none' && maskShape !== undefined && (
                    <>
                        <div className="single-mask-property">
                            <Flex>
                                <FlexBlock>
                                    <label htmlFor={`size-${instanceId}`}>{__('Size', 'faqmate-blocks')}</label>
                                </FlexBlock>
                                <FlexItem>
                                    <SelectControl
                                        id={`size-${instanceId}`}
                                        value={maskSize}
                                        options={MASK_SIZES}
                                        onChange={maskSize => setAttributes({ [`${PREFIX}${controlName}MaskSize`]: maskSize })}
                                    />
                                </FlexItem>
                            </Flex>
                        </div>
                        <div className="single-mask-property">
                            <Flex>
                                <FlexBlock>
                                    <label htmlFor={`position-${instanceId}`}>{__('Position', 'faqmate-blocks')}</label>
                                </FlexBlock>
                                <FlexItem>
                                    <SelectControl
                                        id={`position-${instanceId}`}
                                        value={maskPosition}
                                        options={MASK_POSITIONS}
                                        onChange={maskPosition => setAttributes({ [`${PREFIX}${controlName}MaskPosition`]: maskPosition })}
                                    />
                                </FlexItem>
                            </Flex>
                        </div>
                        <div className="single-mask-property">
                            <Flex>
                                <FlexBlock>
                                    <label htmlFor={`repeat-${instanceId}`}>{__('Repeat', 'faqmate-blocks')}</label>
                                </FlexBlock>
                                <FlexItem>
                                    <SelectControl
                                        id={`repeat-${instanceId}`}
                                        value={maskRepeat}
                                        options={MASK_REPEATS}
                                        onChange={maskRepeat => setAttributes({ [`${PREFIX}${controlName}MaskRepeat`]: maskRepeat })}
                                    />
                                </FlexItem>
                            </Flex>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default withInstanceId(MaskControl);
